import { render, staticRenderFns } from "./NoSideBarMain.vue?vue&type=template&id=14ea3ffa&scoped=true"
import script from "./NoSideBarMain.vue?vue&type=script&lang=js"
export * from "./NoSideBarMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ea3ffa",
  null
  
)

export default component.exports